import { useRef, useState } from 'react';
import { Pressable, TextInput } from 'react-native';
import { FloatingField } from '@/common/components/Fields/FloatingField/FloatingField';
import { Icon } from '@/common/components/Icons/Icon';
import { colors } from '@coverflex-tech/hypernova-design-tokens';
import { styles } from './SearchField.styles';

export interface ISearchFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

export const SearchField = ({
  label,
  value,
  onChange,
  disabled,
  className,
}: ISearchFieldProps) => {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef<TextInput | null>(null);

  return (
    <FloatingField
      focused={focused}
      disabled={disabled}
      className={className}
      onPress={() => inputRef.current?.focus()}
    >
      <Icon icon="magnifying-glass" className={styles.icon} color="neutral20" />
      <TextInput
        className={styles.input({ dirty: !!value })}
        ref={inputRef}
        value={value}
        aria-label={label}
        placeholder={label}
        placeholderTextColor={colors.light.semantic.text.neutral20}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChangeText={onChange}
        allowFontScaling={false}
      />
      {value.length > 0 ? (
        <Pressable onPress={() => onChange('')}>
          <Icon icon="circle-xmark" color="neutral20" />
        </Pressable>
      ) : null}
    </FloatingField>
  );
};
